import { render, staticRenderFns } from "./GatSelect.vue?vue&type=template&id=495e9590&scoped=true"
import script from "./GatSelect.vue?vue&type=script&lang=js"
export * from "./GatSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495e9590",
  null
  
)

export default component.exports